import qs from 'qs';
import { noop, identity } from 'lodash/fp';
import { TIMEOUT } from 'constants/requestOptions';

import filterEmptyParams from './filterEmptyParams';

const defaultOptions = {
  method: 'GET',
  timeout: TIMEOUT,
  formatUrl: ({ url }) => url,
  createProviderOptions: identity,
  headers: { Accept: 'application/json' },
  createId: ({ method, url, body }) =>
    `${method}:${url}:${body ? JSON.stringify(body) : 'none'}`,
  pb: { trickle: noop, done: noop, status: noop, start: noop },
  paramsSerializer: (params) => qs.stringify(filterEmptyParams(params)),
  getIdenticalRequestText: ({ url, id }) =>
    `Identical request. URL: "${url}" ID: "${id}"`,
};

export default function createRequestOptions(globalOptions, reqOptions) {
  const headers = {
    ...defaultOptions.headers,
    ...globalOptions.headers,
    ...reqOptions.headers,
  };

  let options = { ...globalOptions, ...reqOptions };

  options = {
    ...defaultOptions,
    ...options,
    headers,
  };

  const { formatUrl, createId, createProviderOptions } = options;

  options.path = options.url;
  options.url = formatUrl(options);
  options.id = createId(options);
  options.provider = createProviderOptions(options);

  return options;
}
